module.exports = __webpack_public_path__ + "static/media/img_select02.40a87423.jpg";